import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { Cost } from "../../models/cost.model";
import { CostFacadeService } from "./cost-facade.service";

@Injectable({ providedIn: "root" })
export class CostStoreService extends EntityStoreService<
  Cost,
  EntityMetadata,
  CostState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface CostState extends EntityStoreState<CostFacadeService> {}
